import styled from "styled-components";
import { Flex, Text } from "rebass";
import { maxWidth, themeGet } from "styled-system";
import { useEffect } from "react";
import { Arrow } from "./arrow";
import { Publish } from "../utils/event-system";
import SVG from "react-inlinesvg";

const Intro = ({ description, onButtonClick }) => {
  let desc = React.createRef();
  let arrow = React.createRef();
  let title = React.createRef();
  let TimelineLite, Power3, fadeInSettings;

  useEffect(() => {}, []);

  const onFlareReady = () => {
    const GSAP = require("gsap");
    ({ TimelineLite, Power3, Linear } = GSAP);
    fadeInSettings = { opacity: 1, ease: Power3.easeIn };
    new TimelineLite({
      onComplete: () => Publish("intro.complete")
    })
      .to(title.current, 2, { ...fadeInSettings })
      .staggerFrom(".intro-lens-flare polygon", 1, {
        opacity: 0,
        x: "-=20",
        stagger: {
          from: "center",
          amount: 1
        }
      })
      .to(desc.current, 1, { ...fadeInSettings }, "-=1")
      .to(arrow.current, 1, { ...fadeInSettings });
  };

  return (
    <FullViewport
      pt={[3, 3, 3, 7]}
      pb={[4, 5, 6]}
      justifyContent="center"
      alignItems={["center"]}
      px={[3, 3, 3, 4]}
    >
      <Inner maxWidth={0} width={1} textAlign="center">
        <Title as="h1" ref={title} fontFamily="medium" lineHeight={1}>
          <Text fontSize={[24, 7]} letterSpacing={[3.64, 2]}>
            Lighting the way
          </Text>
          <Text
            letterSpacing={4.17}
            mt={[3, 5]}
            mb={[12, 35]}
            fontSize={[2, 5]}
          >
            for
          </Text>
          <OneHundred letterSpacing={[4.64, 13.9]} fontSize={[46, 100]}>
            <span>
              <Flare
                onLoad={onFlareReady}
                className="intro-lens-flare"
                src="/static/images/flare-group.svg"
              />
              100
            </span>{" "}
            Years
          </OneHundred>
        </Title>
        <Description
          ref={desc}
          fontSize={[2, 4]}
          lineHeight={1.5}
          mt={[3, 5]}
          width={1}
          mx="auto"
        >
          {description}
        </Description>
        <ArrowWrapper textAlign={"center"} mt={[3, 5]} ref={arrow}>
          <Arrow
            ariaLabel="Scroll down to next section"
            size={50}
          />
        </ArrowWrapper>
      </Inner>
    </FullViewport>
  );
};

const FullViewport = styled(Flex)`
  min-height: calc(100vh - 58px);
  position: relative;
  overflow: hidden;

  @media screen and (min-width: ${themeGet("breakpoints.3")}) {
    min-height: 100vh;
  }
`;

const OneHundred = styled(Text)`
  > span {
    position: relative;
  }
`;

const Flare = styled(SVG)`
  opacity: 0.7;
  position: absolute;
  top: 0;
  right: 0;
  width: 651px;
  height: 669px;
  transform: translate(47%, -47%);
  max-width: none;

  svg {
    overflow: visible;
    width: 100%;
    height: 100%;
    display: block;
  }
`;

const Inner = styled(Text)`
  ${maxWidth}
`;

const Description = styled(Text)`
  opacity: 0;
`;

const Title = styled(Text)`
  opacity: 0;
  text-transform: uppercase;
`;

const ArrowWrapper = styled(Text)`
  opacity: 0;

  button {
    display: inline-block;
  }
`;

export { Intro };
